var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$route.path == '/dashboard' || _vm.$route.path == '/resource/configurationlist' ? 'dashboard' : 'con']},[_c('keep-alive',{attrs:{"include":_vm.vuexInclude}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }